module.exports = __webpack_public_path__ + "img/4.90b43f35.svg";